export const DEALER_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Distribuidor guardado exitosamente.",
  DISABLE_SUCCESS: "Distribuidor deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Distribuidor habilitado exitosamente.",
};

export const DEALER_MESSAGES_ERROR = {
  SAVE_ERROR: "Error al guardar el distribuidor. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el distribuidor. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el distribuidor. Por favor, inténtalo de nuevo.",
};
